import React from "react";

const IconModels = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 86.02 86.03"
      {...props}
    >
      <path
        d="m51,18.4L67.4,2l16.4,16.4-16.4,16.4-16.4-16.4Z"
        fill="#fff"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="m25.53,3.04c-2.27-4.04-7.96-4.04-10.23,0L.81,28.82c-2.27,4.04.57,9.1,5.12,9.1h28.99c4.55,0,7.39-5.05,5.12-9.1L25.53,3.04Zm41.53,82.99c10.47,0,18.95-8.49,18.95-18.95s-8.49-18.95-18.95-18.95-18.95,8.49-18.95,18.95,8.49,18.95,18.95,18.95Zm-12.49-66.68l12.11,12.11,12.88-12.88-12.11-12.11-12.88,12.88Zm-5.19-3.06c-1.69,1.69-1.69,4.43,0,6.11l14.24,14.24c1.69,1.69,4.43,1.69,6.11,0l15.02-15.02c1.69-1.69,1.69-4.43,0-6.11l-14.24-14.24c-1.69-1.69-4.43-1.69-6.11,0l-15.02,15.02Zm-15.09,31.83c2,0,3.62,1.62,3.62,3.62v30.83c0,2-1.62,3.63-3.61,3.45C16.17,84.3,1.73,69.87.02,51.73c-.19-1.99,1.45-3.61,3.45-3.61h30.83Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default IconModels;
